import React from 'react';
import PropTypes from 'prop-types';
import styles from './PaymentInfoCTA.module.scss';

const PaymentInfoCTA = ({ contactEmail }) => {
  return (
    <div className={styles.help}>
      Unable to pay with credit card? Email us at
      {' '}
      <a href={`mailto:${contactEmail}`} target="_blank" rel="noreferrer">{contactEmail}</a>
      {' '}
      to create an invoice.
    </div>
  );
};

PaymentInfoCTA.propTypes = {
  contactEmail: PropTypes.string.isRequired,
};

export default PaymentInfoCTA;
